var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "content-row content-row-column content-align-start h5video",
      staticStyle: { padding: "0.8rem 0.8rem 0 0.8rem" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("videoPlayer", {
            ref: "videoPlayerRisk",
            staticClass: "vjs-custom-skin",
            staticStyle: { background: "none", width: "100%", height: "100%" },
            attrs: { options: _vm.playerOptions },
            on: {
              play: function($event) {
                _vm.onPlayerPlay($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "font-14 riskdetail",
        staticStyle: {
          margin: "0.8rem 0 0",
          padding: "2px 7px 4px 0",
          "line-height": "25px"
        }
      },
      [
        _c("div", { staticClass: "riskdetailicon" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              color: "#fd6364",
              "margin-left": "1.7rem",
              "margin-top": "4px"
            }
          },
          [_vm._v("症状解读")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7329a470", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7329a470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Risk_ItemVideo.vue
// module id = null
// module chunks = 